import dayjs from "dayjs";
import { useRef } from "react";
import CustomDatePicker from "../../../../../../../components/CustomDatePicker";
import CustomTimePicker from "../../../../../../../components/CustomTimePicker";
import Flex from "../../../../../../../components/Flex";
import { VitalFormik } from "./vital-constant";

export const VitalDateTimeControl = ({ formik }: { formik: VitalFormik }) => {
  const firstSet = useRef<boolean>(
    !!formik.values?.recordedDate && !formik.values?.recordedDate
  );

  const handleDateValue = (date: Date, type: "date" | "time") => {
    if (!date || dayjs().isAfter(date)) return;

    if (type === "time" && formik.values?.recordedDate) {
      const preDate = new Date(formik.values.recordedDate);
      preDate?.setHours(date.getHours(), date.getMinutes(), date.getSeconds());
      formik.setFieldValue("recordedDate", preDate?.toISOString());
    } else {
      if (firstSet.current) {
        handleDateValue(dayjs().toDate(), "date");
        firstSet.current = false;
      }

      formik.setFieldValue("recordedDate", date?.toISOString());
    }
  };

  return (
    <Flex gap={2}>
      <CustomDatePicker
        label="Date"
        name="recordedDate"
        minDate={dayjs()}
        value={formik.values?.recordedDate}
        onChange={(val) => handleDateValue(dayjs(val)?.toDate(), "date")}
        error={formik.errors?.recordedDate}
      />
      <CustomTimePicker
        label="Time"
        minTime={dayjs()}
        name="recordedDate"
        value={formik.values?.recordedDate}
        onChange={(val) => handleDateValue(dayjs(val)?.toDate(), "time")}
        error={formik.errors?.recordedDate}
      />
    </Flex>
  );
};
